import type { AuthenticatedUser } from '../../../auth/types/AuthenticatedUser'
import type { Subproces } from '../types/Subproces'

import {
  type StepConfig,
  canEditSubproces,
  generateStepStatuses,
} from './subproces-util'

export { canEditNetcheck, generateNetcheckStepStatuses }

const NETCHECK_STEPS = [
  { status: 'criteria_klant_verzamelen' },
  { status: 'netcheck_opstarten' },
  { status: 'in_progress' },
  { status: 'done' },
] as const satisfies readonly StepConfig[]

const canEditNetcheck = ({
  user,
  subproces,
}: {
  user: AuthenticatedUser
  subproces: Subproces
}) => canEditSubproces({ user, subproces, mode: 'or' })

const generateNetcheckStepStatuses = ({
  subproces,
}: {
  subproces: Subproces
}) => generateStepStatuses({ subproces, steps: NETCHECK_STEPS })
